var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fe4wq49a0a",
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9zm5-2.5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5c.893 0 1.718-.476 2.165-1.25.447-.774.447-1.726 0-2.5S12.893 6.5 12 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k58zoopbkc",
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g580p73nue",
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x6xh7advdg",
    d: "M0 0H24V24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-137 -665) translate(133 664) translate(4 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7crkgjcs4b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fe4wq49a0a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#7crkgjcs4b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fyjks9l5nd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k58zoopbkc"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#fyjks9l5nd)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6ajj6hwe8f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g580p73nue"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#6ajj6hwe8f)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ojo9ksjizh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x6xh7advdg"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2CA7C0",
    mask: "url(#ojo9ksjizh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/location-blue.0c941a67bbcb156a2587a35fe5532764.svg";
export { ForwardRef as ReactComponent };